import React from 'react';

const Stars = ({ className = "" }) => (
  <svg className={className} width="100" height="100" viewBox="0 0 100 100" fill="none">
    <path d="M30 40 L 33 50 L 27 50 Z" fill="currentColor"/>
    <path d="M60 25 L 64 37 L 56 37 Z" fill="currentColor"/>
    <path d="M45 60 L 48 68 L 42 68 Z" fill="currentColor"/>
    <circle cx="70" cy="50" r="2" fill="currentColor"/>
    <circle cx="25" cy="65" r="2" fill="currentColor"/>
  </svg>
);

export default Stars;